import React, { useEffect, useState } from "react";

import * as M from "components/modal";

import { Modal } from "antd";
import { useAppDispatch, useAppSelector } from "store/store";

import {
  mainModel,
  connectModelSlice,
  propertiesModelSlice,
  reportModelSlice,
} from "store/redux/slices/helperSlices/modelSlice";

const MainModel = ({}: {}) => {
  const [modal1Visible, setModal1Visible] = useState(false);

  const { web3 } = useAppSelector((state) => state.web3Connect);
  const { connectModel, propertiesModel, reportModel, nftIdToReport } = useAppSelector(
    (state) => state.model
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    // if (modelOpen) {
    //   setModal1Visible(true);
    // }
    if (connectModel === true) {
      setModal1Visible(true);
    }
    if (propertiesModel === true) {
      setModal1Visible(true);
    }
    if (reportModel === true) {
      setModal1Visible(true);
    }
  }, [connectModel, propertiesModel, reportModel]);

  const closeModel = () => {
    // dispatch(mainModel(false));
    dispatch(connectModelSlice(false));
    dispatch(propertiesModelSlice(false));
    dispatch(reportModelSlice(false));
    setModal1Visible(false);
  };

  return (
    <div>
      {web3 === null && connectModel ? (
        <Modal
          destroyOnClose={true}
          style={{ top: 20 }}
          visible={modal1Visible}
          centered
          onCancel={closeModel}
        >
          <M.ConnectModel />
        </Modal>
      ) : null}

      {propertiesModel === true ? (
        <Modal
          destroyOnClose={true}
          style={{ top: 20 }}
          visible={modal1Visible}
          centered
          onCancel={closeModel}
        >
          <M.PropertiesModel close={closeModel} />
        </Modal>
      ) : null}

      {reportModel ? (
        <Modal
          destroyOnClose={true}
          style={{ top: 20 }}
          visible={modal1Visible}
          centered
          onCancel={closeModel}
        >
          <M.ReportModel nftId={nftIdToReport} />
        </Modal>
      ) : null}
    </div>
  );
};

export default MainModel;
